export default "__VITE_ASSET__827a31ee__"